import { render, staticRenderFns } from "./PatientCensusRep.vue?vue&type=template&id=7cc78e00&"
import script from "./PatientCensusRep.vue?vue&type=script&lang=js&"
export * from "./PatientCensusRep.vue?vue&type=script&lang=js&"
import style0 from "./PatientCensusRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports